<template>
  <div class="wrapper">
    <h3 class="top-title f-bold">申请提示</h3>
    <p class="tips">您已成功注册易宝支付平台，请选择使用您的入驻资质。</p>
    <div class="qualifications-cont">
      <div class="qualifications-list" v-if="shopList.length > 0">
        <div class="item" :class="merchantNo===item.merchantNo?'item-active':''" v-for="(item, index) in shopList" :key="index" @click="itemsClick(item,index)">
          <div class="item-row">
            <span class="item-row-label">主体类型</span>
            <div class="item-row-cont">{{item.subjectTypeName}}</div>
          </div>
          <div class="item-row">
            <span class="item-row-label">姓名</span>
            <div class="item-row-cont">{{item.signName}}</div>
          </div>
          <div class="item-row">
            <span class="item-row-label">开户名</span>
            <div class="item-row-cont">{{item.bankUserName}}</div>
          </div>
          <div class="item-row">
            <span class="item-row-label">开户账号</span>
            <div class="item-row-cont">{{item.bankCardNo}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="add-btn" :class="merchantNo===''?'disable-btn':''" @click="toNext">下一步</div>
      <!-- <router-link :to="{path: '/distribution/industry-info'}" class="add-btn">下一步</router-link> -->
    </div>
  </div>
</template>
<script>
import { getQualificationInfo} from '@/api/distribution/index';

export default {
  name: 'storeList',
  data() {
    return {
      isShow: false,
      isMobile: false,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      merchantNo: '',
      shopList: []
    }
  },
  created() {
    this.getQualificationInfo();
    this.mobileTerminal((data) => {
      this.isMobile = data;
    })
    setTimeout(() => {
      this.isShow = true;
    }, 1500);
  },
  methods: {
    getQualificationInfo(){
      getQualificationInfo().then(res=>{
        this.shopList = res.data;
      })
    },
    itemsClick(data,index) {
      this.merchantNo = data.merchantNo;
    },
    toNext() {
      if(this.merchantNo==='') return false;
      this.$router.push({
        path: '/distribution/baseinfo-auth?merchantNo=' + this.merchantNo
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top-title{
  color: #222;
  text-align: center;
}
.tips{
  line-height: 1.4;
  color: #222;
  text-align: left;
  margin: 0 auto;
}
@media screen and (max-width:750px){
  .wrapper{
    height: 33.3rem;
    overflow: hidden;
  }
  .top-title{
    height: 4.2rem;
    line-height: 4.2rem;
    font-size: .9rem;
  }
  .tips{
    width: 16.7rem;
    font-size: .8rem;
  }
  .qualifications-cont{
    max-height: 21.5rem;
    margin-top: 1rem;
    padding-top: .05rem;
    overflow-y: scroll;
  }
  .qualifications-list{
    padding-bottom: 5.5rem;
    .item{
      width: 16.75rem;
      background: #FFFFFF;
      border-radius: .5rem;
      border: 1px solid #D8E0F0;
      padding: .6rem .5rem .6rem .7rem;
      box-sizing: border-box;
      margin: 0 auto 1rem;
      cursor: pointer;
      &:last-child{
        margin-bottom: 0;
      }
      &-active{
        border: .15rem solid #47B6C7;
      }
      &-row{
        font-size: .8rem;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        &-label{
          width: 4.2rem;
          line-height: 1.2rem;
          display: inline-block;
          color: #8F8F94;
          text-align: left;
        }
        &-cont{
          width: 11.2rem;
          color: #222;
          font-weight: bold;
        }
      }
    }
  }
  .add-btn{
    width: 15rem;
    height: 2.2rem;
    line-height: 2.2rem;
    background: #47B6C7;
    border-radius: .4rem;
    margin: 0 auto;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    cursor: pointer;
    display: block;
  }
}
@media screen and (min-width:750px){
  .top-title{
    height: 84px;
    line-height: 84px;
    font-size: 18px;
  }
  .tips{
    width: 334px;
    font-size: 16px;
  }
  .qualifications-cont{
    max-height: 426px;
    margin-top: 20px;
    overflow-y: scroll;
  }
  .qualifications-list{
    padding-bottom: 110px;
    .item{
      width: 335px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #D8E0F0;
      padding: 12px 10px 12px 14px;
      box-sizing: border-box;
      margin: 0 auto 20px;
      cursor: pointer;
      &:last-child{
        margin-bottom: 0;
      }
      &-active{
        border: 3px solid #47B6C7;
      }
      &-row{
        font-size: 16px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        &-label{
          width: 84px;
          line-height: 24px;
          display: inline-block;
          color: #8F8F94;
          text-align: left;
        }
        &-cont{
          width: 224px;
          color: #222;
          font-weight: bold;
        }
      }
    }
  }
  .add-btn{
    width: 300px;
    height: 44px;
    line-height: 44px;
    background: #47B6C7;
    border-radius: 8px;
    margin: 0 auto;
    font-size: 16px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    display: block;
  }
  .empty-cont{
    text-align: center;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    .empty-logo{
      width: 70px;
      height: 70px;
      display: block;
      margin: 0 auto;
    }
    p{
      font-size: 14px;
      color: #7D8592;
      text-align: center;
      margin-top: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/distribution/qualifications-list.vue